import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ExperiencesHero from "./components/ExperiencesHero";
import ServicesList from "./components/ServicesList";
import InquiryForm from "./components/InquiryForm";

export default function ExperiencesPage() {
  return (
    <main>
      <Navbar />
      <ExperiencesHero />
      <ServicesList />
      <InquiryForm />
      <Footer />
    </main>
  );
}
